/**
 * Breaks the circular dependency between the Axios layer (which must react
 * to an expired session) and the auth store (which owns logout logic and
 * lives in a React/Zustand context). The store registers its logout
 * handler once at startup; the Axios interceptor only ever knows about
 * this narrow callback.
 */
type SessionExpiredHandler = () => void;

let sessionExpiredHandler: SessionExpiredHandler | null = null;

export function registerSessionExpiredHandler(handler: SessionExpiredHandler): void {
  sessionExpiredHandler = handler;
}

export function notifySessionExpired(): void {
  sessionExpiredHandler?.();
}
